import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Collapse from '../Collapse';
import LinkItems from '../LinkItems';

const FooterContent = props => {
  const { theme, content, providerSet, onLogoutClick } = props;

  if (!content || (content && Object.keys(content).length <= 0)) return null;

  const { links, networks, connect } = content;

  const renderContent = (title, items, themeSection) => (
    <div className={classNames(theme.footerSection, themeSection)}>
      <Collapse theme={theme} title={title}>
        <div className={theme.sectionItemsWrapper}>
          <div className={theme.sectionItems}>
            <LinkItems
              theme={theme}
              items={items}
              providerSet={providerSet}
              onLogoutClick={onLogoutClick}
            />
          </div>
        </div>
      </Collapse>
    </div>
  );

  return (
    <div className={theme.footerContent}>
      {connect && renderContent(connect.title, connect.items, theme.social)}
      {links && networks && (
        <div className={theme.sectionWrapper}>
          {renderContent(links.title, links.items, theme.links)}
          {renderContent(networks.title, networks.items, theme.networks)}
        </div>
      )}
    </div>
  );
};

export default FooterContent;

FooterContent.defaultProps = {
  content: [],
};

FooterContent.propTypes = {
  theme: PropTypes.shape({}),
  content: PropTypes.shape({
    links: PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    networkList: PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    social: PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }),
  onLogoutClick: PropTypes.func,
  providerSet: PropTypes.bool,
};
